
import AppContent from '@components/new-styleguide/AppContent.vue';
import AppHeader from "@components/new-styleguide/AppHeader.vue";
import AppPage from '@components/new-styleguide/AppPage.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'NoVehiclesPage',
  components: {
    AppHeader,
    AppContent,
    AppPage
  }
})
export default class NoVehiclesPage extends Vue {
}

